import { useQuery } from "@tanstack/react-query";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import {
  getBankingAccountsEnvironment,
  type BankEnvironment,
} from "Infrastructure/Api/Api";

const BANK_ACCOUNTS_BY_BANK_QUERY_KEY = "BANK_ACCOUNTS_BY_BANK";

export const bankAccountsByBankKeys = {
  all: [BANK_ACCOUNTS_BY_BANK_QUERY_KEY],
  byBankEnvironment: (bankEnvironment: BankEnvironment | null) => [
    ...bankAccountsByBankKeys.all,
    bankEnvironment,
  ],
};

export const useBankAccountsByBank = (
  bankEnvironment: BankEnvironment | null,
) =>
  useQuery({
    queryKey: bankAccountsByBankKeys.byBankEnvironment(bankEnvironment),
    queryFn: processResponseWithApiProblemDetails(() =>
      getBankingAccountsEnvironment(bankEnvironment ?? undefined),
    ),
    enabled: bankEnvironment !== null,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
